function showLimitedFavoritesCardsNumber(){
    const cardsWrapper = $('.js-tab-section.active .js-cards-wrapper:not(.js-already-shown-all)');

    let arrayOffsetTop = [];
    let uniqueOffsetTop = [];

    cardsWrapper.each(function(index){
        const cards = $(this).find('.js-card');

        cards.each(function(index, element) {
            $(this).addClass('active');
            const elementOffsetTop = $(element).offset().top;
            arrayOffsetTop.push(elementOffsetTop);
            uniqueOffsetTop = [...new Set(arrayOffsetTop)];
        });

        if(window.matchMedia(`(min-width: 1440px)`).matches && uniqueOffsetTop.length > 4) {
            setVisibilityStateForCards(4, uniqueOffsetTop, cards);
            showFavoritesShowMoreBtn($(this));
        } else if(window.matchMedia(`(min-width: 960px)`).matches && uniqueOffsetTop.length > 6) {
            setVisibilityStateForCards(6, uniqueOffsetTop, cards);
            showFavoritesShowMoreBtn($(this));
        } else if(window.matchMedia(`(min-width: 600px)`).matches && uniqueOffsetTop.length > 7) {
            setVisibilityStateForCards(7, uniqueOffsetTop, cards);
            showFavoritesShowMoreBtn($(this));
        } else if(window.matchMedia(`(min-width: 0px)`).matches && uniqueOffsetTop.length > 10) {
            setVisibilityStateForCards(10, uniqueOffsetTop, cards);
            showFavoritesShowMoreBtn($(this));
        } else {
            hideFavoritesShowMoreBtn($(this));
        }
    });
}

$(document).on('favoritesVideosCardsWasCreated', function(){
    showLimitedFavoritesCardsNumber();
});

$(document).on('favoritesTabClicked', function(){
    if(!$('.js-tab-section.active').find('.js-show-more-btn-wrapper.js-already-shown-all').length){
        showLimitedFavoritesCardsNumber();
    }
});

resizeTimer(showLimitedFavoritesCardsNumber, '.js-cards-wrapper', 250);

function setVisibilityStateForCards(rowsToDisplayNumber, uniqueOffsets, cards){
    const edgeOffset = uniqueOffsets[rowsToDisplayNumber];

    cards.each(function(index){
        if($(this).offset().top > edgeOffset - 1){
            $(this).removeClass('active');
        } else {
            $(this).addClass('active');
        }
    });
};

function showFavoritesShowMoreBtn(parent){
    parent.closest('.js-tab-section').find('.js-show-more-btn-wrapper:not(.js-already-shown-all)').addClass('active');
};

function hideFavoritesShowMoreBtn(parent){
    parent.closest('.js-tab-section').find('.js-show-more-btn-wrapper').removeClass('active').addClass('js-already-shown-all');
};

$(document).on('click', '.js-favorites-show-more-btn', function(){
    $(this).closest('.js-tab-section').find('.js-cards-wrapper').addClass('js-already-shown-all');
    $(this).closest('.js-tab-section').find('.js-card').addClass('active');
    $(this).closest('.js-show-more-btn-wrapper').removeClass('active').addClass('js-already-shown-all');
});




